import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Row } from "antd";
import {
  CardTable,
} from "components/card-table";
import { Spinal } from "components/spinal/Spinal";
import { koolstofLayout } from "helpers/arealen-layout";
import { roundAndDisplayWithDecimals } from "helpers/logica/round-and-display-with-decimals";
import { FC } from "react";
import { achtergrondInfoKoolstof } from "../bodem-overig/info/achtergrondInfoKoolstof";
import { bodemkoolstofInvoerRows, InvoerTables, invoerwaardesColumnNames } from "./settings";
import styles from "./styles.module.scss";
import { PercelenModel } from "./models/percelenMock";

interface BodemkoolstofInvoerwaardesProps {
  isEditable: boolean;
  isRefreshing: boolean;
  isKlwReadOnly: boolean;
  isFormChanged: boolean;
  isLoading: boolean;
  percelenModel: PercelenModel;
  klwJaar: number;
  herbereken: () => void;
}

export const BodemkoolstofInvoerwaardes: FC<
BodemkoolstofInvoerwaardesProps
> = ({
  isEditable,
  isRefreshing,
  percelenModel,
  isLoading,
  isFormChanged,
  herbereken,
}) => {
  const kenmerkenMineralenGrondToestanden = percelenModel["kenmerkenMineralen"]["kenmerkenMineralenGrondToestanden"];
  const tableInvoerwaardesValues = [];
  kenmerkenMineralenGrondToestanden.forEach((kenmerkMineraalToestand) => {
    const invoerwaardeColumn = invoerwaardesColumnNames.find((x) => x.kenmerkenMineralenGrondBodemCategorie == kenmerkMineraalToestand.kenmerkenMineralenGrondBodemCategorie);
    if(invoerwaardeColumn !== undefined) {
      const name = invoerwaardeColumn.title;
      const table = invoerwaardeColumn.table;
        tableInvoerwaardesValues.push({
          name,
          table,
          value: [
            {
              type: "bouwConWaarde",
              value: kenmerkMineraalToestand.bouwConWaarde
            },
            {
              type: "bouwWisWaarde",
              value: kenmerkMineraalToestand.bouwWisWaarde
            },
            {
              type: "grasConWaarde",
              value: kenmerkMineraalToestand.grasConWaarde
            },
            {
              type: "grasWisWaarde",
              value: kenmerkMineraalToestand.grasWisWaarde
            },
            {
              type: "natuurWaarde",
              value: kenmerkMineraalToestand.natuurWaarde
            }
          ]
        });
    }});
  return (
    <CardTable>
      <CardTable.Header>
        <CardTable.Header.Title infoContent={achtergrondInfoKoolstof()}>
          Bodemkoolstof invoerwaardes
        </CardTable.Header.Title>
        <CardTable.Header.ColumnTitles>
          {/* subtitles row */}
          <Row style={{paddingRight: 13}} gutter={12}>
            <Col span={koolstofLayout.title}></Col>
            <Col
              span={koolstofLayout.inputGrondenTitleInterval * 3}
              style={{ textAlign: "left" }}
            >
              <h3>Regio</h3>
            </Col>
            <Col 
                span={koolstofLayout.inputGrondenTitleInterval * 3}
                style={{ textAlign: "left" }}
            >
                <h3>Monsters</h3>
              </Col>
          </Row>

          {/* legenda groen boven */}
          <Row gutter={12}
              style={{
                  padding: "5px 0px 5px 0px",
                  marginBottom: 5,
                }} 
                align="bottom">
            <Col span={koolstofLayout.title}>
              Grondgebruik
              <CardTable.ColumnUnit>[ha]</CardTable.ColumnUnit>
            </Col>
            {tableInvoerwaardesValues.filter(x => x.table == InvoerTables.Regio)?.map((kolom) => (
              <Col
                span={koolstofLayout.inputGrondenInterval}
                className="text-right"
              >
                {kolom.name} 
                <CardTable.ColumnUnit>[%]</CardTable.ColumnUnit>
              </Col>
            ))}
           <Col span={koolstofLayout.break} />
           {tableInvoerwaardesValues.filter(x => x.table == InvoerTables.Monsters)?.map((kolom) => (
              <Col
                span={koolstofLayout.inputGrondenInterval}
                className="text-right"
              >
                {kolom.name} 
                <CardTable.ColumnUnit>[%]</CardTable.ColumnUnit>
              </Col>
            ))}
          </Row>

        </CardTable.Header.ColumnTitles>
      </CardTable.Header>
      <div className={isFormChanged && !isEditable ? styles.overlay : ""}>
      <CardTable.Body>
      <Spinal
        initializing={
          !tableInvoerwaardesValues ||
          !kenmerkenMineralenGrondToestanden
        }
        loading={isRefreshing || isLoading}
      >

      {/* default rows */}
      {bodemkoolstofInvoerRows.map((row, index) => (
        <Row
          key={index}
          gutter={12}
          style={{
            padding: "5px 0",
            marginBottom: 5,
          }}
          align="bottom"
        >
         <Col span={koolstofLayout.title}>
              <span style={{ lineHeight: "32px" }}>{row.title}</span>
          </Col>
          {tableInvoerwaardesValues.filter(x => x.table == InvoerTables.Regio).map((tableColumnValue, index) => (
            <Col
              key={index}
              span={koolstofLayout.inputGrondenInterval}
              style={{ textAlign: "right" }}
            >
              <div style={{ paddingRight: 13 }}>
                <span>{roundAndDisplayWithDecimals(2)(tableColumnValue.value.find(x => x.type == row.key).value)}</span>
              </div>
            </Col>
          ))}
          <Col span={koolstofLayout.break} />
          {tableInvoerwaardesValues.filter(x => x.table == InvoerTables.Monsters)?.map((tableColumnValue, index) => (
          <Col
            key={index}
            span={koolstofLayout.inputGrondenInterval}
            style={{ textAlign: "right" }}
          >
            <div style={{ paddingRight: 13 }}>
              <span>{roundAndDisplayWithDecimals(2)(tableColumnValue.value.find(x => x.type == row.key).value)}</span>
            </div>
          </Col>
        ))}
        </Row>
      ))}
      </Spinal>
      {isFormChanged && !isEditable && (
            <Button
              shape="round"
              type="primary"
              className={styles.overlayCenter}
              icon={<FontAwesomeIcon icon={"sync"} />}
              onClick={herbereken}
              loading={isRefreshing}
            >
              Opnieuw berekenen
            </Button>
          )}
      </CardTable.Body>
      </div>
    </CardTable>
  );
};
